import { render } from "./TradeQuoteHasCompleted.vue?vue&type=template&id=140e2fd5&scoped=true"
import script from "./TradeQuoteHasCompleted.vue?vue&type=script&lang=js"
export * from "./TradeQuoteHasCompleted.vue?vue&type=script&lang=js"

import "./TradeQuoteHasCompleted.vue?vue&type=style&index=0&id=140e2fd5&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140e2fd5"]])

export default __exports__